<template>
  <v-btn :to="hrefLink">
    <span>{{ $t(textToShow) }}</span>
    <v-icon>{{ icon }}</v-icon>
  </v-btn>
</template>

<script>
export function createNewBottomBarNavigationItem(hrefLink, textToShow, icon) {
  let item = {};
  item.hrefLink = hrefLink;
  item.textToShow = textToShow;
  item.icon = icon;
  return item;
}

export default {
  props: {
    hrefLink: {
      type: String,
      required: true,
      default: "/",
    },
    textToShow: {
      type: String,
      required: false,
      default: "",
    },
    icon: {
      type: String,
      required: true,
      default: "",
    },
  },
};
</script>

<style></style>
